import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  addDepartment,
  addDepartmentFailed,
  addDepartmentSuccess,
  deleteDepartment,
  deleteDepartmentFailed,
  deleteDepartmentSuccess,
  getDepartments,
  getDepartmentsFailed,
  getDepartmentsSuccess,
} from './slice';
import * as endpoints from './endpoints';

// ----------------------------------------
function* getDepartmentSagas(action: ReturnType<typeof getDepartments>): any {
  try {
    const result = yield call(request.get, endpoints.departments);
    yield put(getDepartmentsSuccess(result.data));
  } catch (err) {
    yield put(getDepartmentsFailed(err));
  }
}
// ----------------------------------------
function* deleteDepartmentSagas(action: ReturnType<typeof deleteDepartment>): any {
  try {
    const { id } = action.payload;

    const result = yield call(request.delete, endpoints.departments, {
      data: {
        id,
      },
    });
    yield put(deleteDepartmentSuccess(result.data));
  } catch (err) {
    yield put(deleteDepartmentFailed(err));
  }
}
// ----------------------------------------
function* addDepartmentSagas(action: ReturnType<typeof addDepartment>): any {
  try {
    const { name, desc, id } = action.payload;
    const result = yield call(request.post, endpoints.departments, {
      id,
      name,
      desc,
    });
    yield put(addDepartmentSuccess(result.data));
  } catch (err) {
    yield put(addDepartmentFailed(err));
  }
}

function* departmentSagas() {
  yield all([
    takeLatest([getDepartments, deleteDepartmentSuccess, addDepartmentSuccess], getDepartmentSagas),
    takeLatest(deleteDepartment, deleteDepartmentSagas),
    takeLatest(addDepartment, addDepartmentSagas),
  ]);
}

export { departmentSagas };
